import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c838d6ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "venda-ordens-producao-vinculadas-tab" }
const _hoisted_2 = {
  class: "ant-row",
  style: {"gap":"10px","flex-wrap":"wrap"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VendaItemOrdemProducaoCard = _resolveComponent("VendaItemOrdemProducaoCard")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itensComOrdensProducao, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.codigo,
        class: "item-com-op-container"
      }, [
        _createElementVNode("h4", null, "Item " + _toDisplayString(item.itemNotaFiscal.codigoProduto) + " - " + _toDisplayString(item.itemNotaFiscal.descricao), 1),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.ordensProducaoVinculadas, (op) => {
            return (_openBlock(), _createBlock(_component_VendaItemOrdemProducaoCard, {
              key: op.codigo,
              "ordem-producao": op
            }, null, 8, ["ordem-producao"]))
          }), 128))
        ]),
        (item !== _ctx.itensComOrdensProducao[_ctx.itensComOrdensProducao.length - 1])
          ? (_openBlock(), _createBlock(_component_a_divider, { key: 0 }))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    (_ctx.itensComOrdensProducao.length === 0)
      ? (_openBlock(), _createBlock(_component_a_empty, {
          key: 0,
          description: "Nenhuma Ordem de Produção vinculada."
        }))
      : _createCommentVNode("", true)
  ]))
}